import { showPledgePayTable } from './pledge-pay-modal-core';
import {
    getPayPledgeFromTableRow,
    getSelectedPayPledges,
    updateSelectedPayPledge,
} from './pay-pledge-map';
import { getPledgePaySurface } from './pledge-pay-surface';
import { getCsrfToken, parsePledgeMoneyAmount } from './pledge-pay-utils';
import { AJAX_TIMEOUT_MESSAGE } from '../helpers.js';
import { showAlertMsg } from '../members/member-show-alert-msg.js';
import { openIndexPage } from '../members/member-open-index-page.js';

let matanahSaveHandlersBound = false;

function matanahSaveUrl(surface) {
    if (surface === 'manager_modal') {
        return '/manager-set-matanah_amount';
    }
    return '/member-set-matanah_amount';
}

function showMatanahMessage($pledgePayBody, message, isError) {
    const $messageContainer = $pledgePayBody.find('#ajaxMsgMatanahAmt');
    $pledgePayBody.find('#matanah_message')
        .removeClass(isError ? 'alert-success' : 'alert-danger')
        .addClass(isError ? 'alert-danger' : 'alert-success');

    const $line = $('<li>');
    $line.append($('<i>').addClass('fa-regular fa-circle-x'));
    $line.append(document.createTextNode('\u00a0' + String(message ?? '')));
    $pledgePayBody.find('#ajaxMsgMatanahAmtUl').empty().append($line);

    clearTimeout($messageContainer.data('hideTimer'));
    $messageContainer.show();
    const hideTimer = setTimeout(() => {
        $messageContainer.fadeOut();
    }, 3000);
    $messageContainer.data('hideTimer', hideTimer);
}

function matanahValidationError($amountInput) {
    const raw = String($amountInput.val() ?? '').trim();
    if (raw === '') {
        return 'The matanah amount you are saving can\'t be empty';
    }
    const amount = parsePledgeMoneyAmount(raw);
    if (!Number.isFinite(amount)) {
        return 'The matanah amount must be a valid number';
    }
    if (amount < 1) {
        return 'The matanah amount you are entering has to be at least $1';
    }
    return null;
}

function applySavedMatanahToPayTable($pledgePayBody, pledge, amount, response, surface) {
    const savedAmount = parsePledgeMoneyAmount(response.amount);
    const savedBalanceDue = parsePledgeMoneyAmount(response.balance_due);
    const normalizedAmount = Number.isFinite(savedAmount) ? savedAmount : amount;

    updateSelectedPayPledge(pledge.table_name, pledge.id, {
        matanah: 0,
        amount: normalizedAmount,
        balance_due: Number.isFinite(savedBalanceDue) ? savedBalanceDue : normalizedAmount,
    });

    const payType = $pledgePayBody.find('#payment_type').val() || 'pay';
    const matanahResult = showPledgePayTable($pledgePayBody, getSelectedPayPledges(), payType, {
        surface,
        payType,
        isRecurringMode: false,
    });
    const remainingMatanahCount = matanahResult
        ? matanahResult.matanahCount
        : $pledgePayBody.find('#matanah_ct').val();
    $pledgePayBody.find('#matanah_ct').val(remainingMatanahCount);

    if (response.already_set) {
        showMatanahMessage($pledgePayBody, 'This matanah pledge amount was already set. The amount shown is up to date.', false);
        return;
    }
    if (remainingMatanahCount < 1) {
        showMatanahMessage($pledgePayBody, 'Matanah pledge amount set. You can now pay the pledge.', false);
        return;
    }
    showMatanahMessage($pledgePayBody, 'Matanah pledge amount set, but there are more amounts to set before you can make a payment.', false);
}

function saveMatanahAmount($saveBtn) {
    const $row = $saveBtn.closest('tr');
    if (!$row.length) {
        throw new Error('saveMatanahAmount: save button is not in a pledge row');
    }
    const pledge = getPayPledgeFromTableRow($row);
    const $pledgePayBody = $saveBtn.closest('#pledge_pay_body');
    if (!$pledgePayBody.length) {
        throw new Error('saveMatanahAmount: #pledge_pay_body is required');
    }
    $pledgePayBody.find('#ajaxMsgMatanahAmt').hide();

    const $amountInput = $row.find('input[name="matanah_amount"]');
    $amountInput.removeClass('matanah-amount--error-border').addClass('matanah-amount--active-border');

    const validationError = matanahValidationError($amountInput);
    if (validationError) {
        showMatanahMessage($pledgePayBody, validationError, true);
        $amountInput.removeClass('matanah-amount--active-border').addClass('matanah-amount--error-border');
        return;
    }

    if ($saveBtn.prop('disabled')) {
        return;
    }
    $saveBtn.prop('disabled', true);

    const amount = parsePledgeMoneyAmount($amountInput.val());
    const surface = getPledgePaySurface($pledgePayBody);

    $.ajax({
        url: matanahSaveUrl(surface),
        type: 'POST',
        data: {
            pledge_id: pledge.id,
            matanah_amount: amount,
            _token: getCsrfToken(),
        },
        success: function (response) {
            if (!response.success) {
                $saveBtn.prop('disabled', false);
                showMatanahMessage($pledgePayBody, response.error, true);
                return;
            }

            try {
                applySavedMatanahToPayTable($pledgePayBody, pledge, amount, response, surface);
            } catch (error) {
                console.error('Failed to refresh pledge list after saving matanah amount', error);
                $saveBtn.prop('disabled', false);
                showMatanahMessage(
                    $pledgePayBody,
                    'Could not refresh the pledge list after saving. Refresh the page and try again.',
                    true
                );
            }
        },
        error: function () {
            $saveBtn.prop('disabled', false);
            showAlertMsg(AJAX_TIMEOUT_MESSAGE, 'danger');
            if (surface !== 'manager_modal') {
                openIndexPage();
            }
        },
    });
}

function bindMatanahSaveHandlers() {
    if (matanahSaveHandlersBound) {
        return;
    }
    matanahSaveHandlersBound = true;
    $(document).on('click', '.matanah-save-btn', function () {
        saveMatanahAmount($(this));
    });
}

export {
    bindMatanahSaveHandlers,
};
